import { render, staticRenderFns } from "./subject-list-add.vue?vue&type=template&id=e21807c8&scoped=true&"
import script from "./subject-list-add.vue?vue&type=script&lang=js&"
export * from "./subject-list-add.vue?vue&type=script&lang=js&"
import style0 from "./subject-list-add.vue?vue&type=style&index=0&id=e21807c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21807c8",
  null
  
)

export default component.exports